module.exports = __webpack_public_path__ + "static/media/best_service.7fb6d18c.png";